import * as React from 'react'
// icons
import SettingsIcon from '@mui/icons-material/Settings'
// constants
import { Modals } from 'constants/index'
// hooks
import { useShowModal } from 'hooks/index'

const PlanTableSettingsButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.PLAN_COLUMNS_SETTINGS_MODAL })

  const openSettings = () => showModal()

  return <SettingsIcon onClick={openSettings} />
}

export default PlanTableSettingsButton
